import i18next from "i18next";

import {
  LocationActivityLog,
  LocationActivityLogType,
} from "../../../models/LocationActivityLog";

export const generateActivityLogDetails = (
  activityLog: LocationActivityLog
): string => {
  const t = (key: string) =>
    i18next.t(`locationActivityPage.locationActivityTable.${key}`);

  const pickupFieldT = (key: string) =>
    i18next.t(`facilityDetailsPage.pickupFields.${key}`);

  const details = activityLog.details;

  switch (activityLog.type) {
    case LocationActivityLogType.HEALTH_INDEX_CHANGE:
      if (!details.new_value) return t("details.health_index_changed");

      if (!details.old_value) {
        return `${t("details.health_index_became")} ${details.new_value.charAt(
          0
        )}`;
      }

      return `${t("details.health_index_changed")} ${details.old_value.charAt(
        0
      )}→${details.new_value.charAt(0)}`;
    case LocationActivityLogType.PICKUP_FIELD_CHANGE:
      if (!details.field) return t("activityLogType.pickup_field");

      return `${t("details.pickup_field_changed")}(${pickupFieldT(
        details.field
      )}): ${t(`details.${details.new_value}`)}`;
    default:
      return t(`type.${activityLog.type}`);
  }
};
